import React, { useEffect, useState } from 'react';
import RibbonActions from '../components/RibbonActions';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getFacturas, registrarPago, updateEstadoFac, getClientes, getProyectos, API_BASE, importarFacturas } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { puede } from '../utils/permisos';
import api from '../services/api';
import { coincide } from '../utils/buscar';
import AutocompleteInput from '../components/AutocompleteInput';
import FiltroPanel from '../components/FiltroPanel';
import ProductoPicker from '../components/ProductoPicker';
import { ModalEmail } from '../components/PrintView';
import SoportesFactura from '../components/SoportesFactura';
import { hoyColombia } from '../utils/fecha';

const SVG_EYE   = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const SVG_EDIT  = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const SVG_CARD  = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>;
const SVG_PRINT = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>;
const SVG_MAIL  = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const SVG_CLIP  = <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16"><path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/></svg>;

// Tasas predefinidas por tipo de retención (Colombia).
const TASAS_RET = {
  retefuente: [0.1, 1, 1.5, 2, 2.5, 3.5, 4, 6, 10, 11],
  reteica:    [4, 5, 6, 6.9, 7, 8, 9.66, 10, 11.04, 13.8],
  reteiva:    [15, 100],
};

const IconBtn = ({ svg, title, onClick, disabled, active }) => {
  const [hover, setHover] = React.useState(false);
  const bg = active ? (hover ? '#15803d' : '#166534') : (hover && !disabled ? '#334155' : '#1e293b');
  return (
    <button title={title} onClick={onClick} disabled={disabled}
      onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
      style={{ background: bg, border:`1px solid ${active ? '#16a34a' : '#334155'}`,
               borderRadius:6, width:26, height:26, cursor: disabled ? 'not-allowed' : 'pointer',
               color: disabled ? '#475569' : active ? '#bbf7d0' : '#e2e8f0',
               display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0,
               opacity: disabled ? 0.45 : 1, transition:'background .15s' }}>
      {svg}
    </button>
  );
};

const ESTADOS = ['borrador','aprobada','pagada','vencida','anulada'];
const EC = { borrador:'#94a3b8', aprobada:'#3b82f6', pagada:'#10b981', vencida:'#ef4444', anulada:'#475569' };
const fmt = (n) => '$' + Number(n || 0).toLocaleString('es-CO');
// Solo visual: quita los ceros de relleno del número (FV0299 → FV299).
// El número real, el CUFE, el XML y el PDF legal NO cambian.
const fmtNum = (n) => String(n || '').replace(/^([A-Za-z]+)0+(?=\d)/, '$1');

const ITEM0 = () => ({ descripcion:'', cantidad:1, unidad:'und', precio_unitario:'', descuento_pct:0, iva_pct:19, impoconsumo_pct:0, tipo_item:'bien' });
const IMPO_OPTS = [{ v: 0, l: '0%' }, { v: 4, l: '4%' }, { v: 8, l: '8%' }, { v: 16, l: '16%' }];
// Responsabilidades fiscales que indican que el CLIENTE es agente retenedor
// (probablemente te practicará retención al pagar).
const RETENEDOR_FISCAL = { 'O-13': 'Gran contribuyente', 'O-15': 'Autorretenedor', 'O-23': 'Agente de retención IVA' };
// Tarifas de retefuente más comunes (sobre el subtotal) para sugerir con un clic.
const RETEF_SUGERIDAS = [['2,5% bienes', 0.025], ['4% servicios', 0.04], ['6% servicios', 0.06], ['11% honorarios', 0.11]];

export default function Facturacion() {
  const navigate    = useNavigate();
  const { user } = useAuth();
  const tieneProyectos = puede(user, 'proyectos'); // ingeniería: ligar factura a proyecto solo si existe el módulo
  const [lista,     setLista]     = useState([]);
  const [clientes,  setClientes]  = useState([]);
  const [proyectos, setProyectos] = useState([]);
  // Recuerda el filtro (empresa/estado/año) durante la sesión: al abrir una
  // factura y volver, la lista sigue filtrada por la misma empresa.
  const savedFacF = (() => { try { return JSON.parse(sessionStorage.getItem('facFiltros')) || {}; } catch { return {}; } })();
  const [filtro,    setFiltro]    = useState(savedFacF.filtro || '');
  const [busq,      setBusq]      = useState(savedFacF.busq || '');
  const [anio,      setAnio]      = useState(savedFacF.anio || '');
  useEffect(() => { try { sessionStorage.setItem('facFiltros', JSON.stringify({ filtro, busq, anio })); } catch {} }, [filtro, busq, anio]);
  const [sp] = useSearchParams();
  const vista = ['actuales', 'nc', 'nd'].includes(sp.get('vista')) ? sp.get('vista') : 'actuales';
  const TIT = { actuales: { h1: 'Facturas', sub: 'Facturas electrónicas DIAN' }, nc: { h1: 'Notas Crédito', sub: 'Notas crédito electrónicas DIAN' }, nd: { h1: 'Notas Débito', sub: 'Notas débito electrónicas DIAN' } }[vista];
  const [modal,     setModal]     = useState(null); // 'nueva'|'pago'|'email'
  const [selected,  setSelected]  = useState(null);
  const [editandoId, setEditandoId] = useState(null);
  const [saving,    setSaving]    = useState(false);
  const [importando, setImportando] = useState(false);
  const importRef = React.useRef(null);
  const [filtroOpen, setFiltroOpen] = useState(false);
  const filtroRef = React.useRef(null);

  const onImportar = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setImportando(true);
    try {
      const fd = new FormData();
      files.forEach(f => fd.append('archivos', f));
      const { data } = await importarFacturas(fd);
      alert(`Importación terminada:\n• Importadas (nuevas): ${data.importadas}\n• Completadas (se les adjuntó el XML): ${data.completadas ?? 0}\n• Duplicadas (ya tenían XML): ${data.duplicadas}\n• Ajenas (otro emisor): ${data.ajenas}\n• Errores: ${data.errores}`);
      load();
    } catch (err) { alert('Error al importar: ' + (err.response?.data?.error || err.message)); }
    finally { setImportando(false); if (importRef.current) importRef.current.value = ''; }
  };
  const [formPago,  setFormPago]  = useState({ monto:'', fecha_pago:'', medio_pago:'transferencia', referencia:'', notas:'', retenciones:[], montoTocado:false });
  const [pagosPrevios, setPagosPrevios] = useState(null); // abonos ya registrados a la factura (null=cargando)

  const [formFac, setFormFac] = useState({
    cliente_id:'', proyecto_id:'', cotizacion_id:'',
    fecha_vencimiento:'', forma_pago:'contado', notas:'',
    retefuente:0, reteica:0,
    condiciones_pago_dias: 0, medio_pago_codigo: '47', medio_pago_desc: 'Transferencia',
    referencia_oc:'',
    items: [ITEM0()],
  });
  const [ordenes,    setOrdenes]    = useState([]);
  const [loadingOC,  setLoadingOC]  = useState(false);

  const load = () => getFacturas(filtro ? { estado: filtro } : {}).then(r => setLista(r.data));
  useEffect(() => {
    load();
    getClientes().then(r => setClientes(r.data));
    if (tieneProyectos) getProyectos().then(r => setProyectos(r.data)).catch(() => {});
    api.get('/compras/ordenes').then(r => setOrdenes(r.data || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [filtro]);
  useEffect(() => {
    if (!filtroOpen) return;
    const h = (e) => { if (filtroRef.current && !filtroRef.current.contains(e.target)) setFiltroOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [filtroOpen]);

  // Cálculo de totales del formulario
  const calcTotales = () => {
    let sub = 0, iva = 0, impo = 0;
    formFac.items.forEach(it => {
      const base = parseFloat(it.cantidad || 0) * parseFloat(it.precio_unitario || 0);
      const desc = base * (parseFloat(it.descuento_pct || 0) / 100);
      const net  = base - desc;
      iva  += net * (parseFloat(it.iva_pct ?? 19) / 100);
      impo += net * (parseFloat(it.impoconsumo_pct || 0) / 100);
      sub  += net;
    });
    const ret  = parseFloat(formFac.retefuente || 0);
    const retic = parseFloat(formFac.reteica   || 0);
    return { sub, iva, impo, ret, retic, total: sub + iva + impo - ret - retic };
  };

  const { sub, iva, impo, ret, retic, total } = calcTotales();
  // Sugerencia automática de retención: si el cliente es agente retenedor.
  const cliSel = clientes.find(c => c.id === formFac.cliente_id);
  const cliRetenedor = cliSel ? RETENEDOR_FISCAL[cliSel.responsabilidad_fiscal] : null;

  const addItem    = () => setFormFac(f => ({ ...f, items: [...f.items, ITEM0()] }));
  const removeItem = i  => setFormFac(f => ({ ...f, items: f.items.filter((_,idx) => idx !== i) }));
  const updItem    = (i, k, v) => setFormFac(f => ({ ...f, items: f.items.map((it,idx) => idx === i ? {...it,[k]:v} : it) }));
  const pickProducto = (i, p) => setFormFac(f => ({ ...f, items: f.items.map((it,idx) => idx === i ? { ...it, descripcion: p.nombre, precio_unitario: Number(p.precio_unitario) || it.precio_unitario, unidad: p.unidad || it.unidad, iva_pct: p.iva_pct ?? it.iva_pct, clasificacion_iva: p.clasificacion_iva ?? it.clasificacion_iva, tipo_item: p.tipo_producto ?? it.tipo_item } : it) }));

  const handleCargarOC = async (ocId) => {
    if (!ocId) return;
    setLoadingOC(true);
    try {
      const { data: oc } = await api.get(`/compras/ordenes/${ocId}`);
      const items = (oc.items || []).map(it => ({
        descripcion:    it.descripcion || '',
        cantidad:       it.cantidad    || 1,
        unidad:         it.unidad      || 'und',
        precio_unitario: it.precio_unitario || '',
        descuento_pct:  0,
        iva_pct:        19,
        impoconsumo_pct: 0,
      }));
      setFormFac(f => ({
        ...f,
        referencia_oc: oc.numero || f.referencia_oc,
        proyecto_id:   oc.proyecto_id || f.proyecto_id,
        items:         items.length ? items : f.items,
        notas:         oc.notas ? (f.notas ? f.notas + '\n' + oc.notas : oc.notas) : f.notas,
      }));
    } catch { alert('No se pudo cargar la OC'); }
    finally { setLoadingOC(false); }
  };

  const RESET_FAC = { cliente_id:'', proyecto_id:'', cotizacion_id:'',
    fecha_vencimiento:'', forma_pago:'contado', notas:'', retefuente:0, reteica:0,
    condiciones_pago_dias:0, medio_pago_codigo:'47', medio_pago_desc:'Transferencia', referencia_oc:'', items:[ITEM0()] };

  const abrirEditar = async (f) => {
    if (f.estado !== 'borrador') return alert('Solo se puede editar una factura en borrador (aún no enviada a la DIAN).');
    try {
      const { data } = await api.get(`/facturacion/${f.id}`);
      setFormFac({
        cliente_id: data.cliente_id || '', proyecto_id: data.proyecto_id || '', cotizacion_id: data.cotizacion_id || '',
        fecha_vencimiento: (data.fecha_vencimiento || '').slice(0, 10), forma_pago: data.forma_pago || 'contado',
        notas: data.notas || '', retefuente: data.retefuente || 0, reteica: data.reteica || 0,
        condiciones_pago_dias: data.condiciones_pago_dias || 0, medio_pago_codigo: data.medio_pago_codigo || '47',
        medio_pago_desc: data.medio_pago_desc || 'Transferencia', referencia_oc: data.referencia_oc || '',
        items: (data.items || []).map(it => ({
          descripcion: it.descripcion, cantidad: it.cantidad, unidad: it.unidad || 'und',
          precio_unitario: it.precio_unitario, descuento_pct: it.descuento_pct || 0,
          iva_pct: it.iva_pct ?? 19, impoconsumo_pct: it.impoconsumo_pct || 0,
          clasificacion_iva: it.clasificacion_iva || undefined, tipo_item: it.tipo_item || 'bien',
        })) || [ITEM0()],
      });
      setEditandoId(f.id); setModal('nueva');
    } catch { alert('No se pudo cargar la factura'); }
  };

  const handleCreate = async () => {
    if (!formFac.cliente_id) return alert('Seleccione un cliente');
    if (formFac.items.some(it => !it.descripcion || !it.precio_unitario))
      return alert('Complete descripción y precio en todos los ítems');
    setSaving(true);
    try {
      if (editandoId) {
        await api.put(`/facturacion/${editandoId}`, formFac);
        const fid = editandoId;
        setEditandoId(null); setFormFac(RESET_FAC); setModal(null);
        navigate(`/facturacion/${fid}`);
      } else {
        const { data: nuevaFac } = await api.post('/facturacion', formFac);
        setFormFac(RESET_FAC); setModal(null);
        navigate(`/facturacion/${nuevaFac.id}`);
      }
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  // Calcula los valores de retención a partir de los % sobre la base de la factura
  // (retefuente y reteICA sobre el subtotal; reteIVA sobre el IVA).
  // Valor de una línea de retención: reteICA usa tasa por mil; el resto, %.
  const valorRet = (r) => {
    const base = Number(r.base || 0), tasa = Number(r.tasa || 0);
    return r.tipo === 'reteica' ? Math.round(base * tasa / 1000) : Math.round(base * tasa / 100);
  };
  // Suma las líneas de retención agrupadas por tipo (retefuente/reteica/reteiva).
  const calcRet = (f, fp) => {
    let rf = 0, ric = 0, riva = 0;
    for (const r of (fp.retenciones || [])) {
      const v = valorRet(r);
      if (r.tipo === 'retefuente') rf += v;
      else if (r.tipo === 'reteica') ric += v;
      else if (r.tipo === 'reteiva') riva += v;
    }
    return { rf, ric, riva, total: rf + ric + riva };
  };
  // Base por defecto según el tipo: reteIVA sobre el IVA; el resto sobre el subtotal.
  const baseDefault = (tipo) => tipo === 'reteiva' ? Number(selected?.iva || 0) : Number(selected?.subtotal || 0);
  // Recalcula el efectivo (monto = saldo − retenciones) si el usuario no lo tocó.
  const recalcMonto = (fp) => { if (!fp.montoTocado) { const r = calcRet(selected, fp); fp.monto = Math.max(0, Number(selected?.saldo || 0) - r.total); } return fp; };
  const addRet = () => setFormPago(fp => recalcMonto({ ...fp, retenciones: [...(fp.retenciones || []), { tipo: 'retefuente', tasa: '', base: baseDefault('retefuente') }] }));
  const setRet = (i, patch) => setFormPago(fp => {
    const retenciones = (fp.retenciones || []).map((r, idx) => {
      if (idx !== i) return r;
      const nr = { ...r, ...patch };
      if (patch.tipo !== undefined) { nr.base = baseDefault(patch.tipo); nr.tasa = ''; } // al cambiar tipo, ajusta base y limpia tasa
      return nr;
    });
    return recalcMonto({ ...fp, retenciones });
  });
  const delRet = (i) => setFormPago(fp => recalcMonto({ ...fp, retenciones: (fp.retenciones || []).filter((_, idx) => idx !== i) }));
  const calcularEfectivo = () => setFormPago(fp => {
    const r = calcRet(selected, fp);
    return { ...fp, monto: Math.max(0, Number(selected?.saldo || 0) - r.total), montoTocado: false };
  });

  const handlePago = async () => {
    const r = calcRet(selected, formPago);
    const abonoTotal = Number(formPago.monto || 0) + r.total;
    if (abonoTotal <= 0) return alert('Ingrese el monto del pago');
    if (abonoTotal - Number(selected.saldo || 0) > 1 &&
        !window.confirm(`El abono (${fmt(abonoTotal)}) excede el saldo pendiente (${fmt(selected.saldo)}). ¿Registrar de todos modos?`)) return;
    setSaving(true);
    try {
      await registrarPago(selected.id, { ...formPago, retefuente: r.rf, reteica: r.ric, reteiva: r.riva });
      setModal(null); setSelected(null); load();
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
    finally { setSaving(false); }
  };

  const handlePrintFac = async (f) => {
    // Abrimos la ventana YA, dentro del gesto del clic, para que no la bloqueen como popup.
    const win = window.open('', '_blank');
    const token = localStorage.getItem('erp_token');
    try {
      const res = await fetch(`${API_BASE}/api/facturacion/${f.id}/pdf?v=${Date.now()}`, { headers: { Authorization: `Bearer ${token}` }, cache: 'no-store' });
      if (!res.ok) throw new Error('pdf');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const nombre = String(f.numero || 'factura').replace(/[^\w.-]/g, '_');
      if (win) {
        // Incrustar el PDF con <embed> dentro de una página HTML: Chrome lo RENDERIZA
        // con su visor aunque esté configurado para "descargar los PDF" (ese ajuste solo
        // afecta la navegación directa a un PDF, no uno incrustado). Así siempre se ve
        // y queda el botón de imprimir del visor.
        win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${nombre}</title>` +
          `<style>html,body{margin:0;padding:0;height:100%;background:#525659}embed{width:100%;height:100%;border:0}</style></head>` +
          `<body><embed src="${url}#toolbar=1" type="application/pdf"></body></html>`);
        win.document.close();
        win.focus();
      } else {
        // Popup bloqueado: descarga como respaldo.
        const a = document.createElement('a'); a.href = url; a.download = `${nombre}.pdf`;
        document.body.appendChild(a); a.click(); document.body.removeChild(a);
      }
      setTimeout(() => URL.revokeObjectURL(url), 120000);
    } catch {
      if (win) win.close();
      alert('Error al generar el PDF');
    }
  };

  const abrirPago = (f) => {
    setSelected(f);
    setFormPago({ monto: f.saldo, fecha_pago: hoyColombia(), medio_pago:'transferencia', referencia:'', notas:'', retenciones:[], montoTocado:false });
    setPagosPrevios(null); // cargando
    setModal('pago');
    api.get(`/facturacion/${f.id}`)
      .then(r => setPagosPrevios(r.data.pagos || []))
      .catch(() => setPagosPrevios([]));
  };

  // Derivados para los filtros de la barra superior y la tabla.
  const fechaFac = (f) => f.fecha || f.fecha_emision || f.created_at;
  // Vencimiento: el registrado, o emisión + 30 días si no tiene.
  const vence = (f) => {
    if (f.fecha_vencimiento) return new Date(f.fecha_vencimiento);
    if (!f.fecha_emision) return null;
    const d = new Date(f.fecha_emision); d.setDate(d.getDate() + 30); return d;
  };
  const anios = [...new Set(lista.map(f => { const d = fechaFac(f); return d ? new Date(d).getFullYear() : null; }).filter(Boolean))].sort((a, b) => b - a);
  const empresas = [...new Set(lista.map(f => f.cliente_nombre).filter(Boolean))].sort();
  // Filtra por tipo según la pestaña: facturas (01/sin marca), NC (91), ND (92).
  const esTipo = (f) => vista === 'nc' ? f.tipo_documento_fe === '91'
    : vista === 'nd' ? f.tipo_documento_fe === '92'
    : (f.tipo_documento_fe !== '91' && f.tipo_documento_fe !== '92');
  const base = lista.filter(esTipo);
  const filtrada = base.filter(f => {
    if (busq && !coincide(busq, f.numero, f.cliente_nombre, f.nit)) return false;
    if (anio) { const d = fechaFac(f); if (!d || String(new Date(d).getFullYear()) !== anio) return false; }
    return true;
  });
  const totalF = filtrada.reduce((a, f) => a + Number(f.total || 0), 0);
  const etiqueta = vista === 'nc' ? 'notas crédito' : vista === 'nd' ? 'notas débito' : 'facturas';

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>{TIT.h1}</h1><p style={s.sub}>{TIT.sub} · {filtrada.length} de {base.length} · {fmt(totalF)}</p></div>
        <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <FiltroPanel
            fields={[
              { tipo: 'input', label: 'Buscar', value: busq, onChange: setBusq, placeholder: 'Número, cliente o NIT…', suggestions: empresas, width: 230 },
              { tipo: 'select', label: 'Estado', value: filtro, onChange: setFiltro, capitalize: true, options: [{ value: '', label: 'Todas' }, ...ESTADOS.map(e => ({ value: e, label: e }))] },
              { tipo: 'select', label: 'Año', value: anio, onChange: setAnio, options: [{ value: '', label: 'Todos' }, ...anios.map(a => ({ value: String(a), label: String(a) }))] },
            ]}
            onClear={() => { setFiltro(''); setBusq(''); setAnio(''); }}
          />
          <input ref={importRef} type="file" accept=".zip,.xml" multiple style={{ display: 'none' }} onChange={onImportar} />
          <button style={s.btnGhost} disabled={importando} onClick={() => importRef.current?.click()}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              {importando ? 'Importando…' : 'Importar (ZIP o XML)'}
            </span>
          </button>
          <button style={s.btnPrimary} onClick={() => { setEditandoId(null); setFormFac(RESET_FAC); setModal('nueva'); }}>+ Nueva factura</button>
        </div></RibbonActions>
      </div>

      {vista !== 'historico' && <>
      <div style={s.card}>
        <table style={s.table}>
          <thead>
            <tr>{['Número','DIAN','Cliente','Proyecto','F. Emisión','F. Vencimiento','Total','Saldo','Estado','Acciones'].map(h =>
              <th key={h} style={s.th}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {filtrada.length === 0 && <tr><td colSpan={10} style={s.empty}>{base.length ? `Ninguna coincide con el filtro` : `Sin ${etiqueta}`}</td></tr>}
            {filtrada.map(f => (
              <tr key={f.id}>
                <td style={{ ...s.td, color:'#93c5fd', fontWeight:600, whiteSpace:'nowrap' }}>
                  {f.tipo_documento_fe === '91' && <span style={s.tagNC}>NC</span>}
                  {f.tipo_documento_fe === '92' && <span style={s.tagND}>ND</span>}
                  {fmtNum(f.numero)}
                </td>
                <td style={s.td}>
                  {(() => {
                    const fe = String(f.estado_fe || '').toLowerCase();
                    const m = fe === 'aceptada' ? { bg:'#02231b', c:'#6ee7b7', t:'Aceptada' }
                      : fe === 'rechazada' ? { bg:'#450a0a', c:'#fca5a5', t:'Rechazada' }
                      : fe ? { bg:'#1e293b', c:'#cbd5e1', t: f.estado_fe }
                      : f.cufe ? { bg:'#02231b', c:'#6ee7b7', t:'Aceptada' }
                      : { bg:'#1e293b', c:'#64748b', t:'Sin enviar' };
                    return <span style={{ ...s.badge, background:m.bg, color:m.c, textTransform:'capitalize' }}>{m.t}</span>;
                  })()}
                </td>
                <td style={s.td}>{f.cliente_nombre}</td>
                <td style={s.td}>{f.proyecto_nombre || '—'}</td>
                <td style={s.td}>{f.fecha_emision ? new Date(f.fecha_emision).toLocaleDateString('es-CO') : '—'}</td>
                <td style={s.td}>{vence(f) ? vence(f).toLocaleDateString('es-CO') : '—'}</td>
                <td style={s.td}>{fmt(f.total)}</td>
                <td style={{ ...s.td, color: Number(f.saldo) > 0 ? '#f59e0b' : '#10b981', fontWeight:600 }}>{fmt(f.saldo)}</td>
                <td style={s.td}>{f.estado === 'anulada' && f.tiene_nc
                  ? <span style={{ ...s.badge, background:'#7c2d1222', color:'#fb923c', fontWeight:400 }}>Nota crédito</span>
                  : <span style={{ ...s.badge, background:EC[f.estado]+'22', color:EC[f.estado] }}>{f.estado}</span>}</td>
                <td style={{ ...s.td, whiteSpace:'nowrap' }}>
                  <div style={{ display:'flex', gap:4, alignItems:'center' }}>
                    <IconBtn title="Ver detalle"       svg={SVG_EYE}   onClick={() => navigate(`/facturacion/${f.id}`)} />
                    {f.estado === 'borrador' && <IconBtn title="Editar (solo borrador)" svg={SVG_EDIT} onClick={() => abrirEditar(f)} />}
                    {(() => { const puede = Number(f.saldo) > 0 && f.estado !== 'anulada' && f.estado !== 'borrador' && f.tipo_documento_fe !== '91' && f.tipo_documento_fe !== '92';
                      return <IconBtn title="Registrar pago / abono" svg={SVG_CARD} onClick={() => puede ? abrirPago(f) : null} disabled={!puede} />; })()}
                    <IconBtn title="Imprimir / PDF"    svg={SVG_PRINT} onClick={() => handlePrintFac(f)} />
                    <IconBtn title={f.email_enviado_en ? `Enviado por correo el ${new Date(f.email_enviado_en).toLocaleDateString('es-CO')}${f.email_enviado_a ? ' a ' + f.email_enviado_a : ''} — reenviar` : 'Enviar por correo'}
                             svg={SVG_MAIL} active={!!f.email_enviado_en} onClick={() => { setSelected(f); setModal('email'); }} />
                    <span style={{ marginLeft:'auto' }}>
                      <IconBtn title="Soportes / adjuntos" svg={SVG_CLIP} onClick={() => { setSelected(f); setModal('soportes'); }} />
                    </span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </>}

      {/* ── Modal email ──────────────────────────────────────────────── */}
      {modal === 'email' && selected && (
        <ModalEmail tipo="factura" id={selected.id} destinatario={selected.cliente_email || ''}
          clienteId={selected.cliente_id} onSent={load}
          onClose={() => { setModal(null); setSelected(null); }} />
      )}

      {modal === 'soportes' && selected && (
        <div style={s.overlay} onClick={() => { setModal(null); setSelected(null); }}>
          <div style={{ ...s.modal, maxWidth:560 }} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <h2 style={s.modalTitle}>📎 Soportes — {selected.numero}</h2>
              <button style={s.closeBtn} onClick={() => { setModal(null); setSelected(null); }}>✕</button>
            </div>
            <div style={{ padding:'18px 20px' }}>
              <SoportesFactura facturaId={selected.id} />
            </div>
          </div>
        </div>
      )}

      {/* ── Modal registrar pago ─────────────────────────────────────── */}
      {modal === 'pago' && selected && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:480 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Registrar pago — {selected.numero}</h2><button style={s.closeBtn} onClick={() => setModal(null)}>✕</button></div>
            <div style={s.modalBody}>
              {(() => {
                const abonado = Number(selected.total || 0) - Number(selected.saldo || 0); // ya pagado (anticipos)
                const nPagos = Array.isArray(pagosPrevios) ? pagosPrevios.length : 0;
                return (
                  <div style={{ ...s.totales, marginBottom:16 }}>
                    <div style={s.totalRow}><span>Total factura</span><span>{fmt(selected.total)}</span></div>
                    {abonado > 0 && (
                      <div style={s.totalRow}>
                        <span>Abonado (anticipo){nPagos > 0 ? ` · ${nPagos} pago${nPagos > 1 ? 's' : ''}` : ''}</span>
                        <span style={{ color:'#10b981' }}>{fmt(abonado)}</span>
                      </div>
                    )}
                    <div style={{ ...s.totalRow, ...s.totalFinal }}><span>Saldo pendiente</span><span style={{ color:'#f59e0b' }}>{fmt(selected.saldo)}</span></div>
                  </div>
                );
              })()}
              <div style={s.row2}>
                <div style={s.field}>
                  <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <label style={{ ...s.label, margin:0 }}>Monto recibido *</label>
                    <button type="button" title="Poner el efectivo que cierra la factura (saldo − retenciones)"
                      style={{ background:'transparent', border:'none', color:'#7dd3fc', fontSize:11, cursor:'pointer', padding:0 }}
                      onClick={calcularEfectivo}>↺ Calcular</button>
                  </div>
                  <input style={s.input} type="number" placeholder="Lo consignado por el cliente" value={formPago.monto} onChange={e => setFormPago({...formPago, monto:e.target.value, montoTocado:true})} /></div>
                <div style={s.field}><label style={s.label}>Fecha pago</label>
                  <input style={s.input} type="date" value={formPago.fecha_pago} onChange={e => setFormPago({...formPago, fecha_pago:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>Medio de pago</label>
                  <select style={s.input} value={formPago.medio_pago} onChange={e => setFormPago({...formPago, medio_pago:e.target.value})}>
                    <option value="transferencia">Transferencia</option>
                    <option value="efectivo">Efectivo</option>
                    <option value="cheque">Cheque</option>
                    <option value="tarjeta">Tarjeta</option>
                  </select></div>
                <div style={s.field}><label style={s.label}>Referencia</label>
                  <input style={s.input} value={formPago.referencia} onChange={e => setFormPago({...formPago, referencia:e.target.value})} /></div>
                <div style={{ ...s.field, gridColumn:'1 / -1' }}>
                  <label style={s.label}>Retenciones que te practicó el cliente</label>
                  {(formPago.retenciones || []).map((r, i) => (
                    <div key={i} style={{ display:'flex', gap:5, alignItems:'center', marginBottom:6 }}>
                      <select style={{ ...s.input, width:108, flexShrink:0, padding:'0 6px' }} value={r.tipo} onChange={e => setRet(i, { tipo: e.target.value })}>
                        <option value="retefuente">Retefuente</option>
                        <option value="reteica">ReteICA</option>
                        <option value="reteiva">ReteIVA</option>
                      </select>
                      <select style={{ ...s.input, width:96, flexShrink:0, padding:'0 6px' }} value={r.tasa} onChange={e => setRet(i, { tasa: e.target.value })}>
                        <option value="">Tasa…</option>
                        {(TASAS_RET[r.tipo] || []).map(v => <option key={v} value={v}>{r.tipo === 'reteica' ? `${v}‰` : `${v}%`}</option>)}
                      </select>
                      <input style={{ ...s.input, flex:1, minWidth:70, padding:'0 8px' }} type="number" placeholder="Base $" value={r.base} onChange={e => setRet(i, { base: e.target.value })} />
                      <span style={{ width:82, textAlign:'right', color:'#93c5fd', fontWeight:600, fontSize:12.5, flexShrink:0 }}>{fmt(valorRet(r))}</span>
                      <button type="button" title="Quitar" onClick={() => delRet(i)} style={{ background:'none', border:'1px solid #7f1d1d', borderRadius:6, color:'#fca5a5', cursor:'pointer', padding:'6px 8px', flexShrink:0, lineHeight:1 }}>✕</button>
                    </div>
                  ))}
                  <button type="button" onClick={addRet} style={{ background:'none', border:'1px dashed #334155', borderRadius:8, color:'#93c5fd', cursor:'pointer', padding:'6px 12px', fontSize:13, marginTop:2 }}>+ Agregar retención</button>
                </div>
              </div>
              {(() => {
                const r = calcRet(selected, formPago);
                const abono = Number(formPago.monto||0) + r.total;
                const dif = Number(selected.saldo||0) - abono; // >0 falta, 0 exacto, <0 excede
                return (
                  <div style={{ ...s.totales, marginTop:14 }}>
                    {r.rf > 0  && <div style={s.totalRow}><span>Total Retefuente</span><span>{fmt(r.rf)}</span></div>}
                    {r.ric > 0 && <div style={s.totalRow}><span>Total ReteICA</span><span>{fmt(r.ric)}</span></div>}
                    {r.riva > 0 && <div style={s.totalRow}><span>Total ReteIVA</span><span>{fmt(r.riva)}</span></div>}
                    <div style={s.totalRow}><span>Efectivo recibido</span><span>{fmt(formPago.monto)}</span></div>
                    <div style={s.totalRow}><span>Abono total (efectivo + retenciones)</span><span>{fmt(abono)}</span></div>
                    {formPago.montoTocado ? (
                      <div style={{ ...s.totalRow, ...s.totalFinal }}>
                        <span>{dif < 0 ? '⚠ Excede el saldo en' : dif > 0 ? 'Saldo tras el pago' : '✓ Cierra exacto'}</span>
                        <span style={{ color: dif > 0 ? '#f59e0b' : dif < 0 ? '#ef4444' : '#10b981' }}>{fmt(Math.abs(dif))}</span>
                      </div>
                    ) : (
                      <div style={{ ...s.totalRow, ...s.totalFinal }}>
                        <span style={{ fontWeight:400, color:'#94a3b8' }}>Cierre automático — recibirás</span>
                        <span style={{ color:'#10b981' }}>{fmt(formPago.monto)}</span>
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handlePago} disabled={saving}>{saving ? 'Guardando...' : 'Registrar pago'}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Modal nueva factura ──────────────────────────────────────── */}
      {modal === 'nueva' && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:820 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>{editandoId ? 'Editar Factura (borrador)' : 'Nueva Factura Electrónica'}</h2><button style={s.closeBtn} onClick={() => { setModal(null); setEditandoId(null); }}>✕</button></div>
            <div style={s.modalBody}>

              <div style={s.row2}>
                <div style={s.field}><label style={s.label}>Cliente *</label>
                  <select style={s.input} value={formFac.cliente_id} onChange={e => setFormFac({...formFac, cliente_id:e.target.value})}>
                    <option value="">Seleccionar cliente</option>
                    {clientes.map(c => <option key={c.id} value={c.id}>{c.razon_social} — {c.nit}</option>)}
                  </select></div>
                {tieneProyectos && (
                <div style={s.field}><label style={s.label}>Proyecto (opcional)</label>
                  <select style={s.input} value={formFac.proyecto_id} onChange={e => setFormFac({...formFac, proyecto_id:e.target.value})}>
                    <option value="">Sin proyecto</option>
                    {proyectos.map(p => <option key={p.id} value={p.id}>{p.codigo} — {p.nombre}</option>)}
                  </select></div>
                )}
              </div>
              {/* ─ Fila 1: Forma de pago | Plazo días | Fecha vencimiento | Medio de pago ─ */}
              <div style={s.row4}>
                <div style={s.field}>
                  <label style={s.label}>Forma de pago</label>
                  <select style={s.input} value={formFac.forma_pago}
                    onChange={e => setFormFac({...formFac, forma_pago:e.target.value,
                      condiciones_pago_dias:0, fecha_vencimiento:''})}>
                    <option value="contado">Contado</option>
                    <option value="credito">Crédito</option>
                  </select>
                </div>
                <div style={s.field}>
                  <label style={s.label}>Plazo (días)</label>
                  <input style={{ ...s.input, opacity: formFac.forma_pago === 'credito' ? 1 : 0.35 }}
                    type="number" min="0" placeholder="30"
                    disabled={formFac.forma_pago !== 'credito'}
                    value={formFac.condiciones_pago_dias || ''}
                    onChange={e => {
                      const dias = parseInt(e.target.value) || 0;
                      const f = new Date();
                      f.setDate(f.getDate() + dias);
                      setFormFac({ ...formFac,
                        condiciones_pago_dias: e.target.value,
                        fecha_vencimiento: dias > 0 ? f.toISOString().slice(0,10) : '',
                      });
                    }} />
                </div>
                <div style={s.field}>
                  <label style={s.label}>Fecha vencimiento</label>
                  <input style={{ ...s.input, opacity: formFac.forma_pago === 'credito' ? 1 : 0.35 }}
                    type="date"
                    disabled={formFac.forma_pago !== 'credito'}
                    value={formFac.fecha_vencimiento}
                    onChange={e => {
                      const fecha = e.target.value;
                      let dias = 0;
                      if (fecha) {
                        const hoy = new Date(); hoy.setHours(0,0,0,0);
                        dias = Math.round((new Date(fecha + 'T00:00:00') - hoy) / 86400000);
                      }
                      setFormFac({ ...formFac,
                        fecha_vencimiento: fecha,
                        condiciones_pago_dias: dias > 0 ? dias : 0,
                      });
                    }} />
                </div>
                <div style={s.field}>
                  <label style={s.label}>Medio de pago (DIAN)</label>
                  <select style={s.input} value={formFac.medio_pago_codigo}
                    onChange={e => {
                      const opts = { '10':'Efectivo','20':'Cheque','42':'Consignación bancaria','47':'Transferencia','48':'Tarjeta crédito','49':'Tarjeta débito' };
                      setFormFac({...formFac, medio_pago_codigo:e.target.value, medio_pago_desc: opts[e.target.value] || 'Transferencia'});
                    }}>
                    <option value="47">47 — Transferencia / ACH</option>
                    <option value="10">10 — Efectivo</option>
                    <option value="20">20 — Cheque</option>
                    <option value="42">42 — Consignación bancaria</option>
                    <option value="48">48 — Tarjeta crédito</option>
                    <option value="49">49 — Tarjeta débito</option>
                  </select>
                </div>
              </div>

              {/* ─ Fila 2: Cargar OC + Referencia ─ */}
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:4 }}>
                <div style={s.field}>
                  <label style={s.label}>📋 Cargar desde Orden de Compra</label>
                  <select style={s.input} defaultValue=""
                    onChange={e => handleCargarOC(e.target.value)}
                    disabled={loadingOC}>
                    <option value="">{loadingOC ? 'Cargando...' : '— Seleccionar OC (opcional) —'}</option>
                    {ordenes.map(o => (
                      <option key={o.id} value={o.id}>
                        {o.numero} — {o.proveedor_nombre || o.proveedor} {o.proyecto_nombre ? `· ${o.proyecto_nombre}` : ''}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={s.field}>
                  <label style={s.label}>OC / Referencia del cliente</label>
                  <input style={s.input} placeholder="Ej. OC-2024-001 o N° pedido del cliente"
                    value={formFac.referencia_oc}
                    onChange={e => setFormFac({...formFac, referencia_oc:e.target.value})} />
                </div>
              </div>

              {/* ─ Ítems ─ */}
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', margin:'16px 0 8px' }}>
                <span style={{ color:'#f1f5f9', fontWeight:600, fontSize:13 }}>Ítems facturados</span>
                <button style={s.btnSmAdd} onClick={addItem} title="Agregar ítem">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:5,verticalAlign:'middle'}}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                  Agregar ítem
                </button>
              </div>
              <div style={s.itemsHead}>
                {['#','Descripción','Cant.','Unidad','Precio unit.','Dto %','IVA %','INC %','Total',''].map(h =>
                  <div key={h} style={{ color:'#64748b', fontSize:11, fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{h}</div>)}
              </div>
              {formFac.items.map((it, i) => {
                const base  = parseFloat(it.cantidad||0)*parseFloat(it.precio_unitario||0);
                const net   = base*(1-(parseFloat(it.descuento_pct||0)/100));
                const tot   = net*(1+(parseFloat(it.iva_pct??19)/100)+(parseFloat(it.impoconsumo_pct||0)/100));
                return (
                  <React.Fragment key={i}>
                  <div style={s.itemRow}>
                    <div style={{ color:'#475569', fontSize:12, fontWeight:600, display:'flex', alignItems:'center', justifyContent:'center' }}>{i + 1}</div>
                    <ProductoPicker style={s.itemCtrl} value={it.descripcion}
                      onChangeText={v => updItem(i, 'descripcion', v)}
                      onPick={p => pickProducto(i, p)} />
                    <input style={s.itemCtrl} type="number" value={it.cantidad} onChange={e => updItem(i,'cantidad',e.target.value)} />
                    <input style={s.itemCtrl} value={it.unidad} onChange={e => updItem(i,'unidad',e.target.value)} />
                    <input style={s.itemCtrl} type="number" placeholder="0" value={it.precio_unitario} onChange={e => updItem(i,'precio_unitario',e.target.value)} />
                    <input style={s.itemCtrl} type="number" min="0" max="100" value={it.descuento_pct} onChange={e => updItem(i,'descuento_pct',e.target.value)} />
                    <select style={s.itemCtrl} value={it.iva_pct} onChange={e => updItem(i,'iva_pct',e.target.value)}>
                      <option value="0">0%</option><option value="5">5%</option><option value="19">19%</option>
                    </select>
                    <select style={s.itemCtrl} value={it.impoconsumo_pct} onChange={e => updItem(i,'impoconsumo_pct',e.target.value)}>
                      {IMPO_OPTS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                    </select>
                    <div style={{ color:'#10b981', fontSize:12, fontWeight:600, display:'flex', alignItems:'center', paddingLeft:2 }}>{fmt(tot)}</div>
                    <div style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
                      {formFac.items.length > 1
                        ? <button style={s.removeBtn} onClick={() => removeItem(i)} title="Eliminar ítem">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                          </button>
                        : null}
                    </div>
                  </div>
                  <div style={{ display:'flex', alignItems:'center', gap:10, padding:'4px 0 8px 34px', fontSize:12, color:'#94a3b8', flexWrap:'wrap' }}>
                    <span>Tipo:</span>
                    <select style={{ ...s.itemCtrl, maxWidth:150 }} value={it.tipo_item || 'bien'} onChange={e => updItem(i, 'tipo_item', e.target.value)}>
                      <option value="bien">Bien</option>
                      <option value="servicio">Servicio</option>
                    </select>
                    {Number(it.iva_pct) === 0 && (
                      <>
                        <span>· IVA 0% →</span>
                        <select style={{ ...s.itemCtrl, maxWidth:280 }}
                          value={it.clasificacion_iva === 'exento' ? 'exento' : 'excluido'}
                          onChange={e => updItem(i, 'clasificacion_iva', e.target.value)}>
                          <option value="excluido">Excluido — no causa IVA</option>
                          <option value="exento">Exento — 0% con derecho a descontable</option>
                        </select>
                      </>
                    )}
                  </div>
                  </React.Fragment>
                );
              })}

              {/* ─ Retenciones ─ */}
              {cliRetenedor && (
                <div style={{ background:'#422006', border:'1px solid #a16207', borderRadius:8, padding:'10px 12px', marginTop:12, fontSize:12.5, color:'#fde68a' }}>
                  💡 <strong>{cliSel.razon_social}</strong> es <strong>agente retenedor</strong> ({cliRetenedor}). Es probable que te practique retención. Aplica la Retefuente que corresponda al concepto:
                  <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginTop:8 }}>
                    {RETEF_SUGERIDAS.map(([l, tasa]) => (
                      <button key={l} type="button"
                        style={{ background:'#1e293b', border:'1px solid #a16207', color:'#fde68a', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' }}
                        onClick={() => setFormFac(f => ({ ...f, retefuente: Math.round(sub * tasa) }))}>{l}</button>
                    ))}
                    <button type="button"
                      style={{ background:'#1e293b', border:'1px solid #475569', color:'#94a3b8', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' }}
                      onClick={() => setFormFac(f => ({ ...f, retefuente: 0 }))}>Sin retefuente</button>
                  </div>
                  <div style={{ marginTop:6, color:'#d97706', fontSize:11 }}>El cálculo es sobre el subtotal ({fmt(sub)}). La ReteICA depende del municipio; ingrésala manual si aplica.</div>
                </div>
              )}
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginTop:12 }}>
                <div style={s.field}><label style={s.label}>ReteFuente ($)</label>
                  <input style={s.input} type="number" value={formFac.retefuente} onChange={e => setFormFac({...formFac, retefuente:e.target.value})} /></div>
                <div style={s.field}><label style={s.label}>ReteICA ($)</label>
                  <input style={s.input} type="number" value={formFac.reteica} onChange={e => setFormFac({...formFac, reteica:e.target.value})} /></div>
              </div>

              {/* ─ Observaciones ─ */}
              <div style={{ marginBottom:12 }}>
                <label style={s.label}>Observaciones / Notas</label>
                <textarea
                  style={{ ...s.input, height:72, padding:'8px 12px', resize:'vertical', lineHeight:1.5 }}
                  placeholder="Observaciones, condiciones especiales, notas para el cliente..."
                  value={formFac.notas}
                  onChange={e => setFormFac({...formFac, notas:e.target.value})} />
              </div>

              {/* ─ Totales ─ */}
              <div style={s.totales}>
                <div style={s.totalRow}><span>Subtotal</span><span>{fmt(sub)}</span></div>
                <div style={s.totalRow}><span>IVA</span><span>{fmt(iva)}</span></div>
                {impo > 0 && <div style={{ ...s.totalRow, color:'#fb923c' }}><span>INC (Impoconsumo)</span><span>{fmt(impo)}</span></div>}
                {ret  > 0 && <div style={{ ...s.totalRow, color:'#f59e0b' }}><span>(-) ReteFuente</span><span>-{fmt(ret)}</span></div>}
                {retic > 0 && <div style={{ ...s.totalRow, color:'#f59e0b' }}><span>(-) ReteICA</span><span>-{fmt(retic)}</span></div>}
                <div style={{ ...s.totalRow, ...s.totalFinal }}><span>Total a cobrar</span><span>{fmt(total)}</span></div>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(null)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleCreate} disabled={saving}>
                {saving ? 'Generando...' : '⚡ Generar factura'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  pageHeader:  { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 },
  h1:          { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:         { color:'#64748b', fontSize:14, margin:0 },
  btnPrimary:  { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnGhost:    { background:'transparent', color:'#94a3b8', border:'1px solid #334155', borderRadius:8, padding:'10px 16px', fontSize:14, cursor:'pointer' },
  tagNC:       { background:'#7c2d12', color:'#fdba74', fontSize:9, fontWeight:700, padding:'1px 5px', borderRadius:4, marginRight:6, verticalAlign:'middle' },
  tagND:       { background:'#1e3a8a', color:'#93c5fd', fontSize:9, fontWeight:700, padding:'1px 5px', borderRadius:4, marginRight:6, verticalAlign:'middle' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  btnSm:       { background:'#166534', color:'#86efac', border:'none', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' },
  btnSmInfo:   { background:'#1e3a5f', color:'#93c5fd', border:'none', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' },
  btnSmAdd:    { background:'#1e293b', color:'#e2e8f0', border:'1px solid #475569', borderRadius:6, padding:'5px 12px', fontSize:12, cursor:'pointer', display:'flex', alignItems:'center' },
  removeBtn:   { background:'transparent', border:'1px solid #475569', color:'#94a3b8', borderRadius:6, padding:'4px 7px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', lineHeight:1 },
  tabs:        { display:'flex', gap:8, marginBottom:16 },
  tab:         { background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', borderRadius:8, padding:'8px 16px', fontSize:13, cursor:'pointer' },
  tabActive:   { background:'#1e3a5f', border:'1px solid #3b82f6', color:'#7dd3fc' },
  filtros:     { display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' },
  chip:        { background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', padding:'6px 14px', borderRadius:20, fontSize:12, cursor:'pointer' },
  fInput:      { background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'0 11px', height:38, boxSizing:'border-box', color:'#f1f5f9', fontSize:13, minWidth:180 },
  iconBox:     { height:38, width:38, boxSizing:'border-box', display:'inline-flex', alignItems:'center', justifyContent:'center', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#94a3b8', cursor:'pointer', padding:0 },
  iconBoxActive:{ background:'#1d4ed8', borderColor:'#1d4ed8', color:'#fff' },
  chipActive:  { background:'#1d4ed8', borderColor:'#1d4ed8', color:'#fff' },
  filtroMenu:  { position:'absolute', top:'calc(100% + 6px)', left:0, zIndex:40, background:'#0f172a', border:'1px solid #334155', borderRadius:10, padding:6, minWidth:180, boxShadow:'0 12px 32px rgba(0,0,0,.45)', display:'flex', flexDirection:'column', gap:2 },
  filtroItem:  { textAlign:'left', background:'transparent', color:'#cbd5e1', border:'none', padding:'8px 12px', borderRadius:6, cursor:'pointer', fontSize:13, textTransform:'capitalize' },
  filtroItemActive:{ background:'#1d4ed8', color:'#fff', fontWeight:600 },
  filtroPanel: { position:'absolute', top:0, right:'calc(100% + 8px)', zIndex:50, background:'#0f172a', border:'1px solid #334155', borderRadius:12, padding:16, display:'flex', gap:20, alignItems:'flex-start', boxShadow:'0 16px 40px rgba(0,0,0,.5)' },
  filtroLabel: { color:'#64748b', fontSize:11, fontWeight:600, textTransform:'uppercase', letterSpacing:'.03em', marginBottom:6 },
  card:        { background:'#1e293b', borderRadius:12, overflow:'auto' },
  table:       { width:'100%', borderCollapse:'collapse', minWidth:900 },
  th:          { padding:'12px 16px', color:'#64748b', fontSize:12, textAlign:'left', borderBottom:'1px solid #334155', background:'#162032', whiteSpace:'nowrap' },
  td:          { padding:'4px 16px', color:'#cbd5e1', fontSize:13, borderBottom:'1px solid #1a2332', verticalAlign:'middle' },
  empty:       { padding:'32px', textAlign:'center', color:'#475569' },
  badge:       { padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600, whiteSpace:'nowrap', display:'inline-block' },
  select:      { background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', borderRadius:6, padding:'3px 8px', fontSize:12, cursor:'pointer' },
  selectSm:    { background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', borderRadius:6, padding:'3px 6px', fontSize:11, cursor:'pointer', maxWidth:100 },
  overlay:     { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:       { background:'#1e293b', borderRadius:16, width:'95%', maxHeight:'92vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155', flexShrink:0 },
  modalTitle:  { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  closeBtn:    { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:   { padding:'14px 20px', overflowY:'auto', flex:1 },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155', flexShrink:0 },
  row2:        { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 },
  row3:        { display:'grid', gridTemplateColumns:'120px 90px 130px', gap:12 },
  row4:        { display:'grid', gridTemplateColumns:'1fr 80px 1.1fr 1.4fr', gap:12 },
  field:       { marginBottom:10 },
  label:       { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:       { width:'100%', height:34, padding:'0 11px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  totales:     { background:'#0f172a', borderRadius:10, padding:'10px 14px', marginTop:10 },
  totalRow:    { display:'flex', justifyContent:'space-between', color:'#94a3b8', fontSize:13, marginBottom:3 },
  totalFinal:  { color:'#f1f5f9', fontWeight:700, fontSize:15, borderTop:'1px solid #334155', paddingTop:6, marginTop:3 },
  itemsHead:   { display:'grid', gridTemplateColumns:'24px 3fr 0.7fr 0.8fr 1.4fr 0.65fr 0.65fr 0.65fr 1.1fr 28px', gap:6, padding:'4px 0 6px', marginBottom:2, alignItems:'center' },
  itemRow:     { display:'grid', gridTemplateColumns:'24px 3fr 0.7fr 0.8fr 1.4fr 0.65fr 0.65fr 0.65fr 1.1fr 28px', gap:6, alignItems:'center', marginBottom:6 },
  itemCtrl:    { width:'100%', height:38, padding:'0 8px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none', cursor:'pointer' },
};
